import api from "./api.js";

export default class TermApi {
  static async getTermList(data) {
    return await api.get(`api/term`, data);
  }

  static async getTermDetail(id) {
    return await api.get(`api/term/${id}`);
  }

  static async editTerm(id, data) {
    return await api.patch(`api/term/${id}`, data);
  }
}
